export default {
  path: 'programs',
  component: () => import(/* webpackChunkName: "artist-programs" */ '@/views/artist/Programs.vue'),
  children: [
    {
      path: '',
      name: 'artist-programs',
      meta: {
        title: 'nav.programs_and_add_ons',
      },
      component: () => import(
        /* webpackChunkName: "artist-programs-list-page" */
        '@/views/artist/programs/ListPage.vue'
        ),
    },
    {
      path: 'convert-hd',
      name: 'convert-hd',
      meta: {
        title: 'nav.programs_and_add_ons',
      },
      component: () => import(
        /* webpackChunkName: "artist-addons-convert-hd-page" */
        '@/views/artist/programs/ConvertHd.vue'
        ),
    },
    {
      path: 'convert-video-image',
      name: 'convert-video-image',
      meta: {
        title: 'nav.programs_and_add_ons',
      },
      component: () => import(
        /* webpackChunkName: "artist-addons-convert-video-image-page" */
        '@/views/artist/programs/ConvertVideoToImageGif.vue'
        ),
    },
    {
      path: 'ftp',
      name: 'ftp',
      meta: {
        title: 'nav.programs_and_add_ons',
      },
      component: () => import(
        /* webpackChunkName: "artist-addons-ftp-page" */
        '@/views/artist/programs/ftp/UploadByFtp.vue'
        ),
    },
    {
      path: 'ftp/change-password',
      name: 'change-ftp-password',
      meta: {
        title: 'nav.programs_and_add_ons',
      },
      component: () => import(
        /* webpackChunkName: "artist-addons-ftp-change-password" */
        '@/views/artist/programs/ftp/ChangeFtpPassword.vue'
        ),
    },
    {
      path: 'gcp/:programId',
      name: 'gcp',
      meta: {
        title: 'nav.programs_and_add_ons',
      },
      component: () => import(
        /* webpackChunkName: "artist-programs-gcp" */
        '@/views/artist/programs/gcp/GcpAgreement.vue'
        ),
    },
  ],
};
